import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";

const NavBar = () => {
  const [nav, setNav] = useState(false);

  const links = [
    { id: 1, link: "home", label: "Home" },
    { id: 2, link: "about", label: "Capabilities" },
    { id: 3, link: "portfolio", label: "Work" },
    { id: 4, link: "experience", label: "Experience" },
    { id: 5, link: "contact", label: "Contact" },
  ];

  return (
    <header className="fixed top-0 z-50 w-full border-b border-white/10 bg-[#080b0d]/90 text-white shadow-lg shadow-black/20 backdrop-blur">
      <nav className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link
          to="home"
          smooth
          duration={500}
          className="cursor-pointer"
          onClick={() => setNav(false)}
        >
          <p className="text-lg font-extrabold tracking-[0.18em] text-white">
            RAJ
          </p>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-emerald-300">
            Software Engineer
          </p>
        </Link>

        <ul className="hidden items-center gap-1 md:flex">
          {links.map(({ id, link, label }) => (
            <li key={id}>
              <Link
                to={link}
                smooth
                duration={500}
                offset={-72}
                className="cursor-pointer rounded-full px-4 py-2 text-sm font-semibold text-zinc-400 transition hover:bg-white/10 hover:text-white"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => setNav(!nav)}
          className="rounded-full border border-white/10 p-3 text-zinc-200 md:hidden"
          aria-label="Toggle navigation"
        >
          {nav ? <FaTimes size={20} /> : <FaBars size={20} />}
        </button>
      </nav>

      {nav && (
        <div className="border-t border-white/10 bg-[#080b0d] px-5 py-5 md:hidden">
          <ul className="mx-auto flex max-w-7xl flex-col gap-2">
            {links.map(({ id, link, label }) => (
              <li key={id}>
                <Link
                  onClick={() => setNav(false)}
                  to={link}
                  smooth
                  duration={500}
                  offset={-72}
                  className="block cursor-pointer rounded-md px-4 py-3 text-lg font-semibold text-zinc-300 hover:bg-white/10 hover:text-white"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default NavBar;
